import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "EditBatch"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M1.5 20.25H22.5V21.75H1.5V20.25zM19.0575 6.74999C19.3392 6.46864 19.4974 6.08686 19.4974 5.68874 19.4974 5.29063 19.3392 4.90885 19.0575 4.62749L16.3725 1.94249C16.0911 1.66083 15.7094 1.50256 15.3113 1.50256 14.9131 1.50256 14.5314 1.66083 14.25 1.94249L3 13.1925V18H7.8075L19.0575 6.74999zM15.3075 2.99999 18 5.69249 15.75 7.94249 13.0575 5.24999 15.3075 2.99999zM4.5 16.5V13.8075L12 6.3075 14.6925 9 7.1925 16.5H4.5zM13.5 16.5H22.5V18H13.5V16.5zM18 12.75H22.5V14.25H18V12.75z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/EditBatch.vue"]]);
